import {Component, ViewChild} from '@angular/core';
import {MenuController, NavController, Platform} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';

import {LoginPage} from "../pages/login/login";
import {AuthService} from "../services/AuthService";
import {MenuItemsProvider} from "../providers/menu-items/menu-items";
import {AgencyConfigFiles, apiconfig, ApplicationConfig, getAppConfiguration} from "./api.config";
import {AgencyConfigService} from "../services/AgencyConfigService";
import {AgencyConfigData} from "../model/Agency";
import {Locupa2Service} from "../services/Locupa2Service";


@Component({
  templateUrl: 'app.html'
})
export class MyApp {

  localApiConfig: any = apiconfig;

  appConfig: ApplicationConfig = getAppConfiguration();
  agencyConfigFiles: any = new AgencyConfigFiles();

  rootPage: any = LoginPage;
  agency: AgencyConfigData = this.agencyConfigService.getAgencyConfigData();


  @ViewChild('content') content: NavController;


  constructor(platform: Platform,
              statusBar: StatusBar,
              splashScreen: SplashScreen,
              private authService: AuthService,
              private menuItemsProvider: MenuItemsProvider,
              private menuCtrl: MenuController,
              private agencyConfigService: AgencyConfigService,
              private locupa2Service: Locupa2Service) {


    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();

      this.setManifestHref();
    });
  }


  /**
   * log out from the menu
   */
  logout(): Promise<any> {
    return this.menuCtrl.close().then(() => {
      this.locupa2Service.closeWindow();
      return this.content.setRoot(LoginPage);
    })
  }


  /**
   * callback on menu open
   */
  menuOpened() {
    //nothing to be done here anymore...
  }

  /**
   * set the given page as Root
   * @param p
   */
  openPage(p: { title: string; i18nKey: string; component: any; locupa2Route?: string; icon: any; badgeValue: any; moduleColor: string; showOnMenu: boolean })  {
    if (p.component){
       this.content.setRoot(p.component)
    }
    else if (p.locupa2Route){
      this.locupa2Service.openLocupa2Window(`/${p.locupa2Route}`);
    }
  }

  reloadMe() {
    console.log('reload me...')
    window.location.reload();
  }

  setManifestHref() {
    let hostname = window.location.hostname;
    document.querySelector('#manifest-placeholder').setAttribute('href', 'assets/manifest/' + this.agencyConfigFiles.hosts[hostname] + '-manifest.json');
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts